import { Col } from "antd";
import React from "react";

const SecondRow = (props) => {
  const { bnavfirst, bnavsecond, bnavthird } = props;

  return (
    <>
      {bnavfirst && (
        <Col flex={1} style={{ marginBottom: "24px" }}>
          <ul>
            {bnavfirst.map((item) => (
              <li className={item.classes[0]}>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        </Col>
      )}
      {bnavsecond && (
        <Col flex={1} style={{ marginBottom: "24px" }}>
          <ul>
            {bnavsecond.map((item) => (
              <li className={item.classes[0]}>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        </Col>
      )}
      {bnavthird && (
        <Col flex={1} style={{ marginBottom: "24px" }}>
          <ul>
            {bnavthird.map((item) => (
              <li className={item.classes[0]}>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        </Col>
      )}
    </>
  );
};

export default SecondRow;
